export const splitFullName = (fullName: string) => {
    const splittedUserName = fullName.trim().split(/(\s).+\s/).join("");
    const user_name = splittedUserName.split(/(\s+)/).filter((e) => e.trim().length > 0);

    return { firstName: user_name && user_name[0] , lastName: user_name && user_name[1] }
};
